export function isSimulationLanguageEnglish(lang) {
  const s = String(lang ?? '').trim().toLowerCase()
  return s === 'en' || s === 'english' || s.startsWith('en-') || s.startsWith('en_')
}
